import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { X, AlertTriangle, Loader2 } from 'lucide-react';
import { useToast } from '../../../src/contexts/ToastContext';
import { rejeitarUg } from './ugAprovacaoActions';

interface RejeitarUgModalProps {
  ugId: string;
  onClose: () => void;
  onRejeitado: () => void;
}

const RejeitarUgModal: React.FC<RejeitarUgModalProps> = ({ ugId, onClose, onRejeitado }) => {
  const { addToast } = useToast();
  const [motivo, setMotivo] = useState('');
  const [saving, setSaving] = useState(false);

  const handleConfirm = async () => {
    if (!motivo.trim()) {
      addToast('Informe o motivo da rejeição.', 'error');
      return;
    }
    setSaving(true);
    try {
      await rejeitarUg(ugId, motivo.trim());
      addToast('UG rejeitada.', 'success');
      onRejeitado();
    } catch (error) {
      console.error('Error rejecting UG', error);
      addToast('Erro ao rejeitar a UG.', 'error');
    } finally {
      setSaving(false);
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md">
        <div className="flex items-center justify-between p-6 border-b border-gray-100 dark:border-gray-700">
          <h2 className="text-lg font-bold text-gray-900 dark:text-white font-poppins flex items-center gap-2">
            <AlertTriangle size={20} className="text-red-500" /> Rejeitar UG
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
            <X size={20} />
          </button>
        </div>

        <div className="p-6 space-y-3">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            A UG fica marcada como rejeitada e não pode ser usada no Simulador até ser aprovada.
          </p>
          <textarea
            value={motivo}
            onChange={e => setMotivo(e.target.value)}
            rows={4}
            placeholder="Motivo da rejeição..."
            className="w-full bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2"
          />
        </div>

        <div className="flex justify-end gap-3 p-6 border-t border-gray-100 dark:border-gray-700">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            disabled={saving}
            className="px-4 py-2 rounded-lg bg-red-600 text-white font-medium hover:bg-red-700 disabled:opacity-60 flex items-center gap-2"
          >
            {saving && <Loader2 size={16} className="animate-spin" />}
            Confirmar Rejeição
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default RejeitarUgModal;
